import { useMemo } from 'react';

import { LazyAutocompleteFieldNotMultiple } from '@occc/ui-design-system';

import {
  makeRetailerNetworkLocationGroupsFilter,
  mapLocationGroupsQueryResponseToRawArray,
} from './add-locations-to-location-group-dialog.utils';
import { LocationGroupSelectItem } from './add-locations-to-location-group-dialog.types';

import { useGetRetailerNetworkLocationGroupsLazy } from '../../../../data-access/queries';

const mapRawLocationGroupResponseItemToAutocompleteOption = (item: LocationGroupSelectItem) => ({
  value: item.uuid,
  label: item.name,
  _raw: item,
});

type LocationGroupSelectProps = {
  retailerNetworkUuid: string;
};

export const LocationGroupSelect = ({ retailerNetworkUuid }: LocationGroupSelectProps) => {
  const makeQueryFilter = useMemo(
    () => makeRetailerNetworkLocationGroupsFilter(retailerNetworkUuid),
    [retailerNetworkUuid],
  );

  return (
    <LazyAutocompleteFieldNotMultiple<
      LocationGroupSelectItem,
      ReturnType<typeof useGetRetailerNetworkLocationGroupsLazy>['response']
    >
      name='locationGroup'
      label='Select a location group'
      useLazyQuery={useGetRetailerNetworkLocationGroupsLazy}
      makeQueryFilter={makeQueryFilter}
      mapQueryResponseToRawArray={mapLocationGroupsQueryResponseToRawArray}
      mapRawResponseItemToAutocompleteOption={mapRawLocationGroupResponseItemToAutocompleteOption}
      inputProps={{ margin: 'none' }}
      first={50}
    />
  );
};
